import { render, staticRenderFns } from "./ServiceListTableComponent.vue?vue&type=template&id=a5652466&scoped=true"
import script from "./ServiceListTableComponent.vue?vue&type=script&lang=js"
export * from "./ServiceListTableComponent.vue?vue&type=script&lang=js"
import style0 from "./ServiceListTableComponent.vue?vue&type=style&index=0&id=a5652466&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5652466",
  null
  
)

export default component.exports